import { useState, useEffect } from "react";
import api from "../api/api"; // Ajusta o caminho da API conforme a tua pasta

export default function SupplyList() {
  const [supplies, setSupplies] = useState([]);
  
  // Estados para o formulário de adição rápida
  const [newName, setNewName] = useState("");
  const [newQuantity, setNewQuantity] = useState(1);
  const [newUrgency, setNewUrgency] = useState("Média");

  // Documentação: Carrega a lista ao abrir a página conectando-se ao Backend
  async function loadSupplies() {
    try {
      const res = await api.get("/supplies");
      setSupplies(res.data || []);
    } catch (err) {
      console.error("Erro ao carregar lista de compras:", err);
    }
  }

  useEffect(() => {
    loadSupplies();
  }, []);

  // Documentação: Função acionada ao submeter o formulário
  const handleAddSupply = async (e) => {
    e.preventDefault(); 
    if (!newName.trim()) return alert("Digite o nome do item que precisa comprar.");

    try {
      await api.post("/supplies", {
        name: newName,
        quantity: parseInt(newQuantity) || 1,
        urgency: newUrgency
      });
      
      setNewName("");
      setNewQuantity(1);
      setNewUrgency("Média");
      loadSupplies();
    } catch (err) {
      alert("Erro ao adicionar item na lista.");
    }
  };

  // Documentação: Alterna entre pendente e comprado
  const toggleStatus = async (id, currentStatus) => {
    const nextStatus = currentStatus === "pendente" ? "comprado" : "pendente";
    try {
      await api.put(`/supplies/${id}`, { status: nextStatus });
      loadSupplies();
    } catch (err) {
      alert("Erro ao atualizar o status da compra.");
    }
  };

  // Documentação: Exclui da base de dados
  const handleDelete = async (id) => {
    if (window.confirm("Deseja remover este item da lista de compras?")) {
      try {
        await api.delete(`/supplies/${id}`);
        loadSupplies();
      } catch (err) {
        alert("Erro ao excluir item.");
      }
    }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 duration-700 p-4 pb-20 bg-transparent space-y-8 relative overflow-x-hidden">
      
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 bg-white/70 backdrop-blur-xl p-8 rounded-[40px] border border-white/50 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-500">
        <div>
          <h1 className="text-4xl font-black text-slate-900 tracking-tighter">Lista de <span className="text-emerald-600">Compras</span></h1>
          <p className="text-[10px] text-slate-400 font-black uppercase tracking-[0.3em] mt-2 ml-1">Aquisição de Suprimentos</p>
        </div>
        
        <form onSubmit={handleAddSupply} className="flex flex-col md:flex-row gap-3 w-full lg:w-auto">
          <input 
            type="text"
            placeholder="Ex: Resma de Papel A4..." 
            className="w-full lg:w-64 p-4 bg-white/80 border border-slate-200/60 rounded-2xl text-sm font-bold shadow-inner outline-none focus:bg-white focus:ring-4 ring-emerald-500/10 focus:border-emerald-400 transition-all placeholder:text-slate-400 uppercase" 
            value={newName} 
            onChange={(e) => setNewName(e.target.value)} 
          />
          
          <input 
            type="number"
            min="1"
            className="w-full lg:w-24 p-4 bg-white/80 border border-slate-200/60 rounded-2xl text-sm font-bold shadow-inner outline-none text-center focus:bg-white focus:ring-4 ring-emerald-500/10 focus:border-emerald-400 transition-all" 
            value={newQuantity} 
            onChange={(e) => setNewQuantity(e.target.value)} 
          />

          <select 
            className="w-full lg:w-32 p-4 bg-white/80 border border-slate-200/60 rounded-2xl text-[11px] font-black uppercase shadow-inner outline-none focus:bg-white focus:ring-4 ring-emerald-500/10 focus:border-emerald-400 transition-all cursor-pointer"
            value={newUrgency}
            onChange={(e) => setNewUrgency(e.target.value)}
          >
            <option value="Baixa">Baixa</option>
            <option value="Média">Média</option>
            <option value="Alta">Alta 🔥</option>
          </select>
          
          <button type="submit" className="px-6 py-4 bg-slate-900 text-white font-black rounded-2xl shadow-xl hover:bg-emerald-600 hover:-translate-y-1 transition-all duration-300 active:scale-95 flex items-center justify-center gap-2 text-[10px] uppercase tracking-widest whitespace-nowrap">
            <span>➕</span> Anotar
          </button>
        </form>
      </div>

      <div className="bg-white/60 backdrop-blur-md rounded-[40px] border border-white/60 shadow-xl shadow-slate-200/40 overflow-hidden transition-all duration-500">
        <table className="w-full text-left table-fixed">
          <thead className="bg-slate-50/60 text-[10px] font-black uppercase text-slate-500 tracking-widest border-b border-slate-200/50">
            <tr>
              <th className="p-6 md:p-8 w-16 text-center">Status</th>
              <th className="p-6 md:p-8 w-1/2">Item a Comprar</th>
              <th className="p-6 md:p-8 text-center w-24">Qtd</th>
              <th className="p-6 md:p-8 text-center w-32">Urgência</th>
              <th className="p-6 md:p-8 text-right w-32">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100/50">
            {/* INÍCIO DO MAP */}
            {supplies.map((item) => {
              const isBought = item.status === 'comprado';
              
              // DOCUMENTAÇÃO: A palavra 'return' abaixo é OBRIGATÓRIA quando usamos chaves {} no map!
              return (
                <tr key={item.id} className={`transition-all duration-300 group border-l-4 ${isBought ? 'bg-emerald-50/30 border-l-emerald-500 opacity-60' : 'hover:bg-white/80 border-l-transparent hover:border-l-slate-400'}`}>
                  
                  <td className="p-6 md:p-8 text-center">
                    <button 
                      onClick={() => toggleStatus(item.id, item.status)}
                      className={`w-8 h-8 rounded-lg flex items-center justify-center shadow-sm transition-all active:scale-90 border ${isBought ? 'bg-emerald-500 border-emerald-600 text-white' : 'bg-white border-slate-300 hover:border-emerald-400'}`}
                    >
                      {isBought && "✓"}
                    </button>
                  </td>

                  <td className="p-6 md:p-8 overflow-hidden">
                    <p className={`font-black text-sm md:text-lg uppercase tracking-tight truncate ${isBought ? 'text-slate-400 line-through' : 'text-slate-800'}`}>
                      {item.name}
                    </p>
                  </td>
                  
                  <td className="p-6 md:p-8 text-center">
                    <span className="font-black text-slate-700 text-lg">{item.quantity}</span>
                  </td>

                  <td className="p-6 md:p-8 text-center">
                    <span className={`px-3 py-1.5 rounded-xl text-[9px] font-black uppercase tracking-widest shadow-sm border ${
                      item.urgency.includes("Alta") ? "bg-rose-50 border-rose-200 text-rose-600" : 
                      item.urgency === "Média" ? "bg-amber-50 border-amber-200 text-amber-600" : 
                      "bg-slate-100 border-slate-200 text-slate-500"
                    }`}>
                      {item.urgency}
                    </span>
                  </td>

                  <td className="p-6 md:p-8 text-right">
                    <button onClick={() => handleDelete(item.id)} className="p-3 bg-white border border-slate-200 text-rose-400 rounded-xl hover:bg-rose-50 hover:text-rose-600 hover:border-rose-200 transition-all shadow-sm" title="Excluir Item">
                      🗑️
                    </button>
                  </td>
                </tr>
              ); // FIM DO RETURN
            })}
            {/* FIM DO MAP */}
            
            {supplies.length === 0 && (
              <tr><td colSpan="5" className="p-20 text-center text-slate-400 font-black uppercase tracking-widest text-[10px]">O caderno do chefe está vazio. Nada para comprar!</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}